module.exports = __webpack_public_path__ + "static/media/lessons.446e0226.svg";